import hooks from '@/hooks'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

DrawerContent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
}

/**
 * @component
 * @param {{
 * children?: Any
 * className?: String
 * }} props
 */
export default function DrawerContent (props) {
  const { children, className } = props
  const mode = hooks.app.useMode()
  const classes = useStyles({ ...props, mode })

  return (
    <div className={clsx(classes.drawerContent, className)}>
      {children}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  drawerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    padding: props => {
      if (props.mode.isMobile) return '32px 16px'
      if (props.mode.isTablet) return '32px 24px'
    },
  },
}))
